"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStructureEditor = void 0;
var react_1 = require("react");
var ai_hub_strategy_api_service_1 = __importDefault(require("../../shared/services/ai-hub-strategy-api.service"));
var change_tracking_1 = require("../utils/change-tracking");
/**
 * Owns the {@link StructureEditor} editing-mode + column/node CRUD logic.
 *
 * The hook never reads `columns` directly back from React state inside its
 * mutators – every change is computed from the current props value to keep
 * the editor controlled by the parent component.
 */
exports.useStructureEditor = function (columns, onColumnsChange, onLayerEditingChange) {
    var _a = react_1.useState(null), editingColumnId = _a[0], setEditingColumnId = _a[1];
    var _b = react_1.useState(""), editingColumnName = _b[0], setEditingColumnName = _b[1];
    var _c = react_1.useState(""), originalColumnName = _c[0], setOriginalColumnName = _c[1];
    var _d = react_1.useState(columns.map(function (c) { return c.id; })), expandedLayerIds = _d[0], setExpandedLayerIds = _d[1];
    var _e = react_1.useState(false), historyOpen = _e[0], setHistoryOpen = _e[1];
    var _f = react_1.useState([]), strategyHistory = _f[0], setStrategyHistory = _f[1];
    var _g = react_1.useState(false), isLoadingHistory = _g[0], setIsLoadingHistory = _g[1];
    // Sync expanded layer ids with the current columns: keep user's
    // expand/collapse state for existing layers, auto-expand brand-new ids
    // (e.g. freshly added layers, or all ids on first load / strategy switch),
    // and drop ids that no longer exist.
    var knownColumnIdsRef = react_1.useRef(new Set(columns.map(function (c) { return c.id; })));
    react_1.useEffect(function () {
        var currentIds = columns.map(function (c) { return c.id; });
        var currentIdSet = new Set(currentIds);
        var known = knownColumnIdsRef.current;
        var newIds = currentIds.filter(function (id) { return !known.has(id); });
        setExpandedLayerIds(function (prev) {
            var preserved = prev.filter(function (id) { return currentIdSet.has(id); });
            var toAdd = newIds.filter(function (id) { return !preserved.includes(id); });
            if (toAdd.length === 0 && preserved.length === prev.length) {
                return prev;
            }
            return __spreadArrays(preserved, toAdd);
        });
        knownColumnIdsRef.current = currentIdSet;
    }, [columns]);
    // Notify parent when layer inline-editing state changes
    react_1.useEffect(function () {
        if (onLayerEditingChange) {
            onLayerEditingChange(editingColumnId !== null);
        }
    }, [editingColumnId, onLayerEditingChange]);
    // Clear editing state if the column being edited no longer exists
    react_1.useEffect(function () {
        if (editingColumnId && !columns.find(function (c) { return c.id === editingColumnId; })) {
            setEditingColumnId(null);
            setEditingColumnName("");
            setOriginalColumnName("");
        }
    }, [columns, editingColumnId]);
    var loadHistory = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allHistory, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoadingHistory(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ai_hub_strategy_api_service_1.default.getAllHistoricalChangeHistory()];
                case 2:
                    allHistory = _b.sent();
                    setStrategyHistory(allHistory || []);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setStrategyHistory([]);
                    return [3 /*break*/, 4];
                case 4:
                    setIsLoadingHistory(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var toggleHistory = function () {
        var wasOpen = historyOpen;
        setHistoryOpen(!wasOpen);
        if (!wasOpen) {
            loadHistory();
        }
    };
    var toggleLayerExpanded = function (id) {
        setExpandedLayerIds(expandedLayerIds.includes(id)
            ? expandedLayerIds.filter(function (layerId) { return layerId !== id; })
            : __spreadArrays(expandedLayerIds, [id]));
    };
    // ── Column actions ───────────────────────────────────────────────
    var addColumn = function () {
        var columnIds = columns
            .map(function (c) { return parseInt(c.id, 10); })
            .filter(function (id) { return !isNaN(id) && isFinite(id); });
        var nextColId = String(columnIds.length === 0 ? 1 : Math.max.apply(Math, columnIds) + 1);
        onColumnsChange(__spreadArrays(columns, [
            { id: nextColId, name: "New Column", nodes: [] },
        ]));
        setOriginalColumnName("New Column");
        setEditingColumnId(nextColId);
        setEditingColumnName("New Column");
        setExpandedLayerIds(__spreadArrays(expandedLayerIds, [nextColId]));
    };
    var deleteColumn = function (id) {
        if (editingColumnId === id) {
            setEditingColumnId(null);
        }
        onColumnsChange(columns.filter(function (c) { return c.id !== id; }));
        setExpandedLayerIds(expandedLayerIds.filter(function (layerId) { return layerId !== id; }));
    };
    var startColumnEdit = function (column) {
        setOriginalColumnName(column.name);
        setEditingColumnId(column.id);
        setEditingColumnName(column.name);
    };
    var confirmColumnEdit = function () {
        if (!editingColumnId)
            return;
        if (!editingColumnName) {
            onColumnsChange(columns.map(function (c) {
                return c.id === editingColumnId ? __assign(__assign({}, c), { name: "Untitled" }) : c;
            }));
        }
        setEditingColumnId(null);
        setEditingColumnName("");
        setOriginalColumnName("");
    };
    var cancelColumnEdit = function () {
        if (editingColumnId) {
            onColumnsChange(columns.map(function (c) {
                return c.id === editingColumnId ? __assign(__assign({}, c), { name: originalColumnName }) : c;
            }));
        }
        setEditingColumnId(null);
        setEditingColumnName("");
        setOriginalColumnName("");
    };
    // ── Node actions ─────────────────────────────────────────────────
    var addNode = function (columnId) {
        onColumnsChange(columns.map(function (col) {
            if (col.id !== columnId)
                return col;
            // P3-2: append a short random suffix to avoid same-millisecond
            // collisions on rapid "Add Element" presses.
            var randomSuffix = Math.random().toString(36).slice(2, 8);
            var newNode = {
                id: "node-" + columnId + "-" + Date.now() + "-" + randomSuffix,
                name: "New Strategy Element",
                edges: {},
            };
            return __assign(__assign({}, col), { nodes: __spreadArrays((col.nodes || []), [newNode]) });
        }));
    };
    var updateNode = function (columnId, nodeId, updates) {
        onColumnsChange(columns.map(function (col) {
            if (col.id !== columnId)
                return col;
            return __assign(__assign({}, col), { nodes: (col.nodes || []).map(function (node) {
                    return node.id === nodeId ? __assign(__assign({}, node), updates) : node;
                }) });
        }));
    };
    var deleteNode = function (columnId, nodeId) {
        onColumnsChange(columns.map(function (col) {
            if (col.id === columnId) {
                return __assign(__assign({}, col), { nodes: (col.nodes || []).filter(function (node) { return node.id !== nodeId; }) });
            }
            // Strip references to deleted node from edges in other layers via
            // the prototype-pollution-safe helper (P1-1).
            return __assign(__assign({}, col), { nodes: (col.nodes || []).map(function (node) {
                    var edges = node.edges || {};
                    if (edges[nodeId] === undefined)
                        return node;
                    return __assign(__assign({}, node), { edges: change_tracking_1.safeDeleteEdge(edges, nodeId) });
                }) });
        }));
    };
    var updateConnectionWeight = function (columnId, nodeId, targetNodeId, weightType) {
        onColumnsChange(columns.map(function (col) {
            if (col.id !== columnId)
                return col;
            return __assign(__assign({}, col), { nodes: (col.nodes || []).map(function (node) {
                    if (node.id !== nodeId)
                        return node;
                    return __assign(__assign({}, node), { edges: change_tracking_1.safeWriteEdge(node.edges || {}, targetNodeId, weightType) });
                }) });
        }));
    };
    return {
        editingColumnId: editingColumnId,
        editingColumnName: editingColumnName,
        setEditingColumnName: setEditingColumnName,
        startColumnEdit: startColumnEdit,
        confirmColumnEdit: confirmColumnEdit,
        cancelColumnEdit: cancelColumnEdit,
        expandedLayerIds: expandedLayerIds,
        toggleLayerExpanded: toggleLayerExpanded,
        addColumn: addColumn,
        deleteColumn: deleteColumn,
        addNode: addNode,
        updateNode: updateNode,
        deleteNode: deleteNode,
        updateConnectionWeight: updateConnectionWeight,
        historyOpen: historyOpen,
        toggleHistory: toggleHistory,
        strategyHistory: strategyHistory,
        isLoadingHistory: isLoadingHistory,
    };
};
